import React, { useState } from 'react';
import styled from 'styled-components';
import { Divider, Link, MessagePlugin, Space } from 'tdesign-react';
import doCopy from 'copy-to-clipboard';
import SvgIcon from '@/components/SvgIcon';

export default function SecretDisplay({ children, ...others }) {
  const [visible, setVisible] = useState(false);

  const toggle = () => setVisible((v) => !v);

  const handleCopy = () => {
    doCopy(children);
    MessagePlugin.info('已拷贝');
  };

  return visible ? (
    <Root {...others}>
      {children}
      <Space style={{ marginLeft: 10 }} size={0} separator={<Divider layout='vertical' />}>
        <Link onClick={handleCopy} theme='primary' hover='color'>
          复制
        </Link>
        <Link onClick={toggle} theme='primary' hover='color'>
          收起
        </Link>
      </Space>
    </Root>
  ) : (
    <Space size='small'>
      <span>*******</span>
      <Icon onClick={toggle} type='eye' />
    </Space>
  );
}

const Root = styled.div``;

const Icon = styled(SvgIcon)`
  color: var(--td-font-gray-2);
  cursor: pointer;
`;
